import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { useFormik } from "formik";

export function CredentialDialog({ onSubmit, open, onClose }) {
  const formik = useFormik({
    initialValues: {
      admin: {
        id: "",
        password: "",
      },
    },
    onSubmit: async (values) => {
      onSubmit(values.admin);
      onClose();
    },
  });
  // Dialog as form
  return (
    <Dialog open={open} onClose={onClose} maxWidth={"xs"}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>Credentials</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Admin ID"
                {...formik.getFieldProps("admin.id")}
                autoComplete="admin-id"
                fullWidth
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Admin Password"
                type="password"
                autoComplete="admin-password"
                {...formik.getFieldProps("admin.password")}
                fullWidth
                variant="outlined"
                size="small"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              onClose();
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button color="primary" variant="contained" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
